import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import Header from "components/Header";
import { DataGrid } from "@mui/x-data-grid";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DataGridCustomToolbar from "components/DataGridCustomToolbar";
import { useGetTransactionsQuery } from "state/api";
const OurTeams = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [search, setSearch] = useState("");

  const [searchInput, setSearchInput] = useState("");
  const [teams, setTeams] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [formData, setFormData] = useState({ name: "", position: "", linkedin: "",instagram:"",facebook:"", image: "" });
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");


  const data = useGetTransactionsQuery(search);
  console.log('DATA',data,"Search>>",search,"this is input:",searchInput)
  // Fetch team members from the API
const fetchTeams = async () => {
    try {
      const response = await axios.get(`${apiUrl}/ourteam/getteam`);
      setTeams(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching team members:", error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchTeams();
  }, []);
  const handleImageUpload = async (file, setImagePath) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(`${apiUrl}/upload`, formData);
      console.log("this is image path>>:", response.data.url);
      // setImagePath(response.data.filePath);
      setImagePath(response.data.url);
    } catch (error) {
      console.error("Error uploading image:", error);
      setErrorMessage("Error uploading image.");
      setSnackbarOpen(true);
    }
  };

  const handleFileChange = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleImageUpload(selectedImage, setImagePath);
    }
  };

  

  // Open the form for adding or editing
  const handleOpenModal = (team = null) => {
    setSelectedTeam(team);
    setFormData(team ? { ...team, links: team.links || ["", "", ""], image: "" } : { name: "", position: "", linkedin:"" ,facebook:"",instagram:"", image: "" });

    setImagePath(team ? team.image : "");
    setOpenModal(true);
    setErrors({});
  };

  // Close the form
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedTeam(null);
    setErrors({});
  };

  // Handle form data change
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevFormData) => ({
    ...prevFormData,
    [name]: value,
  }));
};



  // Form validation function
// Form validation function
const validateForm = () => {
  const newErrors = {};

  if (!formData.name.trim()) {
    newErrors.name = "Name is required.";
  }
  if (!formData.position.trim()) {
    newErrors.position = "Position is required.";
  }

  const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i;

  if (!formData.facebook.trim()) {
    newErrors.link1 = "Facebook link is required.";
  } else if (!urlPattern.test(formData.facebook)) {
    newErrors.link1 = "Facebook link must be a valid URL.";
  }

  if (!formData.instagram.trim()) {
    newErrors.link2 = "Instagram link is required.";
  } else if (!urlPattern.test(formData.instagram)) {
    newErrors.link2 = "Instagram link must be a valid URL.";
  }

  if (!formData.linkedin.trim()) {
    newErrors.link3 = "LinkedIn link is required.";
  } else if (!urlPattern.test(formData.linkedin)) {
    newErrors.link3 = "LinkedIn link must be a valid URL.";
  }

  if (!imagePath.trim()) {
    newErrors.image = "Image is required.";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


  // Add or update a team member
  const handleSubmit = async () => {
    if (!validateForm()) {
      return; // Stop submission if the form is invalid
    }

    try {
      if (selectedTeam) {
        // Update team member
        await axios.put(`${apiUrl}/ourteam/updateteam/${selectedTeam._id}`, {
          ...formData,
          image: imagePath,
        });
        setTeams((prevData) =>
          prevData.map((item) => (item._id === selectedTeam._id ? { ...formData, image: imagePath } : item))
        );
      } else {
        // Create a new team member
        const response = await axios.post(`${apiUrl}/ourteam/createteam`, {
          ...formData,
          image: imagePath,
        });
        setTeams((prevData) => [...prevData, response.data]);
      }
      handleCloseModal();
    } catch (error) {
      console.error("Error saving team member:", error);
      setErrorMessage("Error saving team member.");
      setSnackbarOpen(true);
    }
  };

  // Delete a team member
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/ourteam/deleteteam/${id}`);
      setTeams((prevData) => prevData.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting team member:", error);
      setErrorMessage("Error deleting team member.");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const columns = [
     
    { field: "name", headerName: "Name", flex: 0.5 },
    { field: "position", headerName: "Position", flex: 0.5 },
    {
      field: "image",
      headerName: "Image",
      flex: 0.5,
      renderCell: (params) => (
        <img src={params.row.image} alt={params.row.title} width="50" height="50" />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleOpenModal(params.row)}
            style={{ marginRight: 8, backgroundColor: "#4d547d" }}
          >
            Update
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => handleDelete(params.row._id)}
            style={{ backgroundColor: "white", color: "#191f45" }}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="OUR TEAMS" subtitle="Our Teams List" />
      <Button variant="contained" color="primary" onClick={() => handleOpenModal(null)}>
        Add Team Member
      </Button>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>{selectedTeam ? "Update Team Member" : "Add Team Member"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            name="name"
            value={formData.name}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name}
          />
          <TextField
            margin="dense"
            label="Position"
            type="text"
            fullWidth
            variant="outlined"
            name="position"
            value={formData.position}
            onChange={handleChange}
            error={!!errors.position}
            helperText={errors.position}
          />
          <TextField
            margin="dense"
            label="Add your facebook Link"
            fullWidth
            variant="outlined"
            name="facebook"
            value={formData.facebook}
            onChange={handleChange}
            error={!!errors.link1}
            helperText={errors.link1}
          />
          <TextField
            margin="dense"
            label="Add your instagram Link "
            fullWidth
            variant="outlined"
            name="instagram"
            value={formData.instagram}
            onChange={handleChange}
            error={!!errors.link2}
            helperText={errors.link2}
          />
          <TextField
            margin="dense"
            label="Add your LinkedIn Link"
            fullWidth
            variant="outlined"
            name="linkedin"
            value={formData.linkedin}
            onChange={handleChange}
            error={!!errors.link3}
            helperText={errors.link3}
          />

          <Button variant="outlined" component="label" startIcon={<CloudUploadIcon />}>
            Upload Image
            <input type="file" hidden onChange={handleFileChange} />
          </Button>
          {errors.image && (
            <Typography color="error" variant="body2">
              {errors.image}
            </Typography>
          )}
          {imagePath && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              <img src={imagePath} alt="image" width="50" height="50" />
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            {selectedTeam ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box mt="40px" height="75vh">
        <DataGrid
          loading={isLoading}
          getRowId={(row) => row._id}
          rows={teams || []}
          columns={columns}
          pageSize={5}
          sx={{ backgroundColor: "#191f45", color: "white" }}
          components={{ Toolbar: DataGridCustomToolbar }}
          componentsProps={{
            toolbar: { searchInput, setSearchInput, setSearch },
          }}
        />
      </Box>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default OurTeams;
